export function applyLocaleFromQuery(vm) {
  if (!vm || !vm.$route || !vm.$i18n) {
    return;
  }
  const lang = String(vm.$route.query.lang || "").toLowerCase();
  if (lang === "en") {
    vm.$i18n.locale = "EN";
  }
}
